<template>
  <div>
    <div class="page-title">New Entity</div>
    <Notice v-if="envAgnostic" type="info" title="Environment Agnostic">
      This entity will be shared across staging and production.
    </Notice>
    <Form v-if="form" v-model="form" :submit="create" btnText="Add Entity" />
    <Spinner v-else />
  </div>
</template>

<script>
import Form from "./_form.data-loader-entities.page";
export default {
  components: { Form },
  metaInfo() {
    return {
      title: "New Entity",
    };
  },
  data() {
    return {
      form: null,
    };
  },
  created() {
    this.setForm();
  },
  beforeDestroy() {
    this.$store.commit("ui/setEnvAgnostic", false);
  },
  methods: {
    async setForm() {
      const { data } = await this.$api.DataLoaderEntity.new({
        schema_id: this.$route.params.schema_id,
      });
      delete data.page;
      if (data.schema?.environment_agnostic) {
        this.$store.commit("ui/setEnvAgnostic", true);
      }

      if (data.schema.schema_type === "page") {
        const { data: data2 } = await this.$api.Page.new();
        data2.project_id = this.currentUser.active_project.id;
        data2.add_to_menu = "hidden";
        if (data.schema.enable_lenis_by_default) data2.enable_lenis = true;
        this.form = {
          ...data,
          schema_id: this.$route.params.schema_id,
          page_attributes: data2,
        };
      } else {
        this.form = {
          ...data,
          schema_id: this.$route.params.schema_id,
        };
      }
    },
    async create() {
      await this.$api.DataLoaderEntity.create(this.form);
      this.$router.push("/content-management");
    },
  },
};
</script>

<style></style>
